//
//
//
//
//

const COMPONENT_NAME = 'loading'

export default {
  name: COMPONENT_NAME,
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Scroll/Loading/index.vue